<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Categories</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>
      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <button mat-button class="icon-btn" [matMenuTriggerFor]="columnMenu">
      <svg-icon src="assets/svg/paper-pencil.svg" svgClass="grey"></svg-icon>
    </button>
    <button *ngIf="hasActiveFilters" mat-button (click)="resetAllFilters()">
      Reset Filters
    </button>

    <mat-menu
      class="mat-menu-elaphant vertical-menu column-menu"
      #columnMenu="matMenu"
    >
      <div class="column-options">
        <mat-checkbox
          *ngFor="let column of filterableColumns"
          [checked]="!!column.selected"
          color="lightGreen"
          (click)="$event.stopPropagation()"
          (change)="onColumnSelectionChange($event, column)"
          >{{ column.name }}</mat-checkbox
        >
      </div>
    </mat-menu>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="hasWrite"
      mat-button
      color="lightGreen"
      (click)="create()"
    >
      Create New Category
    </button>
  </div>
</div>

<div class="categories-list">
  <div class="container categories-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Categories</div>
      <div class="options">
        <button
          *ngIf="hasWrite"
          mat-icon-button
          [matMenuTriggerFor]="menu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu #menu="matMenu" class="vertical-menu">
          <button
            *ngIf="hasWrite"
            mat-menu-item
            (click)="create()"
            class="icon-btn-w-text"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>New Category</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="container-content"
      lhpeElementLoader
      #elementLoader="elementloader"
    >
      <table
        #categoriesTable
        mat-table
        [dataSource]="dataSource"
        matSort
      >
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let c">{{ c.id }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Category Name
          </th>
          <td mat-cell *matCellDef="let c">{{ c.name }}</td>
        </ng-container>

        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Icon</th>
          <td mat-cell *matCellDef="let c">
            <span *ngIf="c.media; else noIcon">{{ c.media.description || c.media.name }}</span>
            <ng-template #noIcon>
              <span class="no-icon">No icon</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Account ID Column -->
        <ng-container matColumnDef="account_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Account ID</th>
          <td mat-cell *matCellDef="let c">{{ c.account_id }}</td>
        </ng-container>

        <!-- Options Column -->
        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let c" class="options-cell">
            <button
              *ngIf="hasWrite"
              mat-button
              class="icon-btn"
              (click)="edit(c)"
            >
              <svg-icon src="assets/svg/pencil.svg" svgClass="lightBlue"></svg-icon>
            </button>
            <button
              *ngIf="hasRemove"
              mat-button
              class="icon-btn"
              (click)="delete(c)"
            >
              <svg-icon src="assets/svg/trashcan.svg" svgClass="lightBlue"></svg-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="perPage"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
